import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustStrip } from './components/TrustStrip';
import { Services } from './components/Services';
import { About } from './components/About';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-dark selection:bg-gold/30 selection:text-navy" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustStrip data-id="element-4" />
        <Services data-id="element-5" />
        <About data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Contact data-id="element-9" />
      </main>
      <Footer data-id="element-10" />

      {/* Mobile Sticky CTA */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 p-4 bg-navy/95 backdrop-blur-sm border-t border-gold/20 z-40" data-id="element-11">
        <a href="#contact" className="block w-full bg-gold text-navy font-bold text-center py-3 rounded shadow-lg" data-id="element-12">
          Get a Free Quote
        </a>
      </div>
    </div>;
}